// @generated by protoc-gen-es v1.10.0
// @generated from file penumbra/core/asset/v1/asset.proto (package penumbra.core.asset.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { Any, proto3 } from "@bufbuild/protobuf";
import { Amount } from "../../num/v1/num_pb.js";

/**
 * @generated from message penumbra.core.asset.v1.BalanceCommitment
 */
export const BalanceCommitment = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.BalanceCommitment",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
  ],
);

/**
 * A Penumbra asset ID.
 *
 * @generated from message penumbra.core.asset.v1.AssetId
 */
export const AssetId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.AssetId",
  () => [
    { no: 1, name: "inner", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "alt_bech32m", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "alt_base_denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message penumbra.core.asset.v1.Denom
 */
export const Denom = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.Denom",
  () => [
    { no: 1, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Describes metadata about a given asset.
 *
 * @generated from message penumbra.core.asset.v1.Metadata
 */
export const Metadata = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.Metadata",
  () => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "denom_units", kind: "message", T: DenomUnit, repeated: true },
    { no: 3, name: "base", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "display", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "symbol", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1984, name: "penumbra_asset_id", kind: "message", T: AssetId },
    { no: 1985, name: "images", kind: "message", T: AssetImage, repeated: true },
    { no: 1986, name: "priority_score", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * DenomUnit represents a struct that describes a given denomination unit of the basic token.
 *
 * @generated from message penumbra.core.asset.v1.DenomUnit
 */
export const DenomUnit = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.DenomUnit",
  () => [
    { no: 1, name: "denom", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "exponent", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "aliases", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message penumbra.core.asset.v1.Value
 */
export const Value = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.Value",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 2, name: "asset_id", kind: "message", T: AssetId },
  ],
);

/**
 * Represents a value of a known or unknown denomination.
 *
 * @generated from message penumbra.core.asset.v1.ValueView
 */
export const ValueView = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.ValueView",
  () => [
    { no: 1, name: "known_asset_id", kind: "message", T: ValueView_KnownAssetId, oneof: "value_view" },
    { no: 2, name: "unknown_asset_id", kind: "message", T: ValueView_UnknownAssetId, oneof: "value_view" },
  ],
);

/**
 * A value whose asset ID is known and has metadata.
 *
 * @generated from message penumbra.core.asset.v1.ValueView.KnownAssetId
 */
export const ValueView_KnownAssetId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.ValueView.KnownAssetId",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 2, name: "metadata", kind: "message", T: Metadata },
    { no: 3, name: "equivalent_values", kind: "message", T: EquivalentValue, repeated: true },
    { no: 4, name: "extended_metadata", kind: "message", T: Any },
  ],
  {localName: "ValueView_KnownAssetId"},
);

/**
 * A value whose asset ID is unknown, with no metadata.
 *
 * @generated from message penumbra.core.asset.v1.ValueView.UnknownAssetId
 */
export const ValueView_UnknownAssetId = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.ValueView.UnknownAssetId",
  () => [
    { no: 1, name: "amount", kind: "message", T: Amount },
    { no: 2, name: "asset_id", kind: "message", T: AssetId },
  ],
  {localName: "ValueView_UnknownAssetId"},
);

/**
 * An image related to an asset.
 *
 * @generated from message penumbra.core.asset.v1.AssetImage
 */
export const AssetImage = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.AssetImage",
  () => [
    { no: 1, name: "png", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "svg", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "theme", kind: "message", T: AssetImage_Theme },
  ],
);

/**
 * @generated from message penumbra.core.asset.v1.AssetImage.Theme
 */
export const AssetImage_Theme = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.AssetImage.Theme",
  () => [
    { no: 1, name: "primary_color_hex", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "circle", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "dark_mode", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
  {localName: "AssetImage_Theme"},
);

/**
 * The estimated price of one asset in terms of a numeraire.
 *
 * This is used for generating "equivalent values" in ValueViews.
 *
 * @generated from message penumbra.core.asset.v1.EstimatedPrice
 */
export const EstimatedPrice = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.EstimatedPrice",
  () => [
    { no: 1, name: "priced_asset", kind: "message", T: AssetId },
    { no: 2, name: "numeraire", kind: "message", T: AssetId },
    { no: 3, name: "numeraire_per_unit", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "as_of_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

/**
 * An "equivalent" value to a given value, in terms of a numeraire.
 *
 * For instance, this can provide a USD-equivalent value relative to a
 * stablecoin, or an amount of the staking token, etc.  A view server can
 * optionally include this information to assist a frontend in displaying
 * information about the value in a user-friendly way.
 *
 * @generated from message penumbra.core.asset.v1.EquivalentValue
 */
export const EquivalentValue = /*@__PURE__*/ proto3.makeMessageType(
  "penumbra.core.asset.v1.EquivalentValue",
  () => [
    { no: 1, name: "equivalent_amount", kind: "message", T: Amount },
    { no: 2, name: "numeraire", kind: "message", T: Metadata },
    { no: 3, name: "as_of_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
  ],
);

